import React from 'react';

const CheckboxGroup = ({ 
  label, 
  options, 
  selectedValues, 
  onChange, 
  required = false,
  error = null 
}) => {
  const handleCheckboxChange = (value) => {
    const newValues = selectedValues.includes(value)
      ? selectedValues.filter(v => v !== value)
      : [...selectedValues, value];
    onChange(newValues);
  };

  return (
    <div className="mb-6">
      <label className="block text-base font-medium text-gray-700 mb-3">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="grid grid-cols-1 gap-2 max-h-64 overflow-y-auto">
        {options.map((option) => (
          <label key={option.value} className="flex items-center space-x-2 cursor-pointer p-2 hover:bg-gray-50 rounded">
            <input
              type="checkbox"
              checked={selectedValues.includes(option.value)}
              onChange={() => handleCheckboxChange(option.value)}
              className="w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500 flex-shrink-0"
            />
            <span className="text-base text-gray-700 leading-tight">{option.label}</span>
          </label>
        ))}
      </div>
      {error && (
        <p className="text-red-500 text-base mt-1">{error}</p>
      )}
    </div>
  );
};

export default CheckboxGroup;
